import React, { Fragment, Component } from 'react';
import { Redirect } from 'react-router';
import { branch, compose, renderComponent } from 'recompose';
import Routes from './routes';
import { CheckoutLoading } from './containers/status';
import { Cart, Nav, ArticleDetail } from './containers/ui';
import { GeneralLoading } from './components/loading';

class Shop extends Component {
  render() {
    return (
      <Fragment>
        <Routes />
        <Nav />
        <Cart />
        <CheckoutLoading />
        <ArticleDetail />
      </Fragment>
    );
  }
}

/* eslint-disable */
const withVerification = WrappedComponent => props => {
  const { auth, authenticateUser, history } = props;

  const verificationRequired = auth !== "success";
  const verificationInProgress = auth === "fetching";

  if (verificationRequired) {
    if (verificationInProgress) return <GeneralLoading />;
    authenticateUser();
    return <GeneralLoading />;
  }

  if (verificationInProgress) return null;

  return <WrappedComponent {...props} />;
};
/* eslint-enable */

const redirectIfAuthRequired = authRequired =>
  branch(authRequired, renderComponent(() => <Redirect to="/login" />));

const enhance = compose(
  redirectIfAuthRequired(props => {
    return props.auth === 'loginRequired';
  }),
  withVerification
);

export default enhance(Shop);



// WEBPACK FOOTER //
// ./src/ShopComponent.js